import React, { Fragment } from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';
import i18next from 'i18next';

const Loading = ({ showLoading }) => {
    return (
        <Fragment>
            <Dimmer active={showLoading}>
                <Loader size='large'>{i18next.language ? `${i18next.t('general.loading')}...` : ''}</Loader>
            </Dimmer>
        </Fragment>
    );
};

export default Loading;


